module.exports = __webpack_public_path__ + "img/plus-update.d4d709f1.svg";